module.exports = __webpack_public_path__ + "static/media/story.2c564d74.svg";